import { Role } from './role.model';
import { constants } from '../utils/constants';

interface ISession {
  accessToken: string;
  refreshToken: string;
  ttl: number;
  userIdToken: string;
  profilingToken?: string;
  customToken?: string;
}

interface IUserData {
  lastAccess: Date;
  name: string;
  idNumber?: number;
  idType?: string;
  companyName?: string;
  companyId?: string;
  roles: Role[];
  permissions: number[];
  administrator: boolean;
  email?: string;
  userId?: string;
  personId?: string;
  firstName?: string;
  lastName?: string;
  firstLogin?: boolean;
}

export class UserLogged {
  public sessionData: ISession;
  public userData: IUserData;

  constructor(sessionData?: ISession, userData?: IUserData) {
    this.sessionData = sessionData;
    this.userData = userData;
  }

  setSessionData(session: ISession) {
    this.sessionData = session;
  }

  getSessionData(): ISession {
    return this.sessionData;
  }

  setUserData(userData: IUserData) {
    
    this.userData = userData;
  }

  getUserData(): IUserData {
    return this.userData;
  }

  isExecutive(): boolean {
    return (
      this.hasRole(constants.rules.codes.roles.admin.value) &&
      this.userData.administrator
    );
  }

  isAdmin(): boolean {
    return (
      this.hasRole(constants.rules.codes.roles.admin.value) &&
      !this.userData.administrator
    );
  }

  getHomeUrl(): string {
    if (this.isExecutive()) {
      return "/pages/home/executive";
    }
    if (this.isAdmin()) {
      return "/pages/home/user-management";
    }
    return "/pages/home/last-requests";
  }

  getUserManagementUrl(): string {
    if (this.isAdmin()) {
      return '/pages/home/user-management';
    } else {
      return '/pages/admin/user-management'
    }
  }

  hasPermission(permissionId: number): boolean {
    return this.getUserData().permissions.includes(permissionId);
  }

  hasRole(roleId: number): boolean {
    return this.getUserData().roles.filter(role => role.id === roleId).length > 0;
  }
}
